// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetHostConfigByIdAsyncRequestModel from '../../model/get-widget-host-config-by-id-async-request-model';
import GetWidgetHostConfigByIdAsyncRequestDTO from '../dto/get-widget-host-config-by-id-async-request-dto';
import dtoSchema from '../schemas/get-widget-host-config-by-id-async-request-schema';

export default abstract class GetWidgetHostConfigByIdAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetHostConfigByIdAsyncRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetWidgetHostConfigByIdAsyncRequestDTO>): GetWidgetHostConfigByIdAsyncRequestModel;
  static toModel(dto: DeepPartial<GetWidgetHostConfigByIdAsyncRequestDTO> | undefined | null): GetWidgetHostConfigByIdAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetHostConfigByIdAsyncRequestDTO> | undefined | null): GetWidgetHostConfigByIdAsyncRequestModel | undefined {
    return dto ? new GetWidgetHostConfigByIdAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetHostConfigByIdAsyncRequestModel> | GetWidgetHostConfigByIdAsyncRequestModel): GetWidgetHostConfigByIdAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWidgetHostConfigByIdAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetHostConfigByIdAsyncRequestModel, can not map to GetWidgetHostConfigByIdAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
